// removed by extract-text-webpack-plugin
module.exports = {"title":"_3TH8mdqFQpcx_VBWzfijsO","countChartInfo":"xNeQpjKa6ihyKChj84Uv4","countChart":"_2-jdJIcPV-L1sGrEKDseWW","chartInfo":"_1G-k3sE5xmMMzC_vJR5VOM","chartInfoSelected":"_3D5kN7ovmWnD7yyYryh12E","chartInfoFill":"_1hTRvTJyFXW1b1g565aarO","selectedChartInfo":"_1Pp4bz9oaiY878Vya4dFAH","invoiceId":"_2aXnPXzUctG2Z-92_znEcA","boxCount":"hn9eLr53mOOZB5esdFiPp"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets/BoxCountChart/widget.scss
// module id = 1220
// module chunks = 0